// extracted by mini-css-extract-plugin
module.exports = {"heading_h1":"styles_heading_h1__KQ9_6","heading_h2":"styles_heading_h2__J13_M","heading_h3":"styles_heading_h3__MI7vx"};